module.exports = __webpack_public_path__ + "img/5.6efa1e7b.svg";